module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-324.69aca17.woff2";